const style = require('_metronic/assets/sass/style.scss')
export default style
